import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { noop } from 'lodash';
import { replace } from 'connected-react-router';
import {
  selectors as sharedTabsSelectors,
  deleteSharedTab,
} from '@store/sharedTabs';
import { DASHBOARD_TYPE, HOME_LONG_PATH } from '@utils/constants';
import {
  getCustomTitle, getOkText, getCancelText, getDashboardTitle,
} from '@components/common/sharedTabMessage';

import { toggleUpdatePopupVisible, changeSaveDashboardPromptVisibility } from '@store/dashboards/ui/actions';
import { useHistory } from 'react-router-dom';
import DashboardTab from '../DashboardTabs/TemporaryDashboardTabs/DashboardTab';

export default (currentId) => {
  const dispatch = useDispatch();
  const { tabs: sharedTabsData } = useSelector(sharedTabsSelectors);
  const history = useHistory();

  const goToHomePage = (currentShareId, tab) => {
    if (currentShareId === tab.id) {
      history.push(HOME_LONG_PATH);
    }
  };

  const getSaveFunction = (tab) => {
    switch (true) {
    case tab.type === DASHBOARD_TYPE.ERROR_DIAGNOSTICS:
      return () => { dispatch(toggleUpdatePopupVisible(true, tab.id)); };
    case tab.type === DASHBOARD_TYPE.OVB:
    case tab.type === DASHBOARD_TYPE.ML:
    case tab.type === DASHBOARD_TYPE.COMPARE:
    case tab.type === DASHBOARD_TYPE.NOC:
    case tab.type === DASHBOARD_TYPE.VIEWER_MODULE:
      return () => { dispatch(changeSaveDashboardPromptVisibility(true, tab.id)); };
    case tab.type === DASHBOARD_TYPE.TIMELINE:
      return () => {
        dispatch(deleteSharedTab(tab.id));
        goToHomePage(currentId, tab);
      };
    default:
      return null;
    }
  };

  const getRemoveFunction = (tab) => {
    switch (true) {
    case tab.type === DASHBOARD_TYPE.OVB:
    case tab.type === DASHBOARD_TYPE.ML:
    case tab.type === DASHBOARD_TYPE.NOC:
    case tab.type === DASHBOARD_TYPE.ERROR_DIAGNOSTICS:
    case tab.type === DASHBOARD_TYPE.COMPARE:
    case tab.type === DASHBOARD_TYPE.VIEWER_MODULE:
    case tab.type === DASHBOARD_TYPE.TRENDS:
    case tab.type === DASHBOARD_TYPE.AI_ALERT_DIAGNOSTICS:
    case tab.type === DASHBOARD_TYPE.APP_EXPERIENCE:
      return () => {
        dispatch(deleteSharedTab(tab.id));
        goToHomePage(currentId, tab);
      };
    case tab.type === DASHBOARD_TYPE.TIMELINE:
      return noop;
    default:
      return noop;
    }
  };

  const getReplace = (tab) => {
    switch (true) {
    case tab.type === DASHBOARD_TYPE.OVB:
    case tab.type === DASHBOARD_TYPE.ML:
    case tab.type === DASHBOARD_TYPE.NOC:
    case tab.type === DASHBOARD_TYPE.VIEWER_MODULE:
      return replace;
    case tab.type === DASHBOARD_TYPE.ERROR_DIAGNOSTICS:
      return replace;
    case tab.type === DASHBOARD_TYPE.COMPARE:
    case tab.type === DASHBOARD_TYPE.TIMELINE:
    case tab.type === DASHBOARD_TYPE.TRENDS:
    case tab.type === DASHBOARD_TYPE.AI_ALERT_DIAGNOSTICS:
    default:
      return null;
    }
  };

  const renderSharedTabsFunc = tabStyles => sharedTabsData.map(tab => (
    <DashboardTab
      id={tab.id}
      key={tab.id}
      isSharing
      dashboard={{
        title: getDashboardTitle(tab),
        dashboard: tab.state,
        type: tab.type,
        unsaved: true,
      }}
      isActive={currentId == tab.id} // string vs int tab id issue
      className={tabStyles.unsaved}
      isSaved
      customTitle={getCustomTitle(tab.type)}
      // tslint:disable-next-line:jsx-no-lambda
      onSave={getSaveFunction(tab)}
      remove={getRemoveFunction(tab)}
      okText={getOkText(tab.type)}
      cancelText={getCancelText(tab.type)}
      replace={getReplace(tab)}
      prevDashboard={null}
    />
  ));

  return renderSharedTabsFunc;
};
